import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-unknown-error-messages',
    templateUrl: './unknown-error-messages.component.html',
    styleUrls: ['./unknown-error-messages.component.scss']
})
export class UnknownErrorMessagesComponent implements OnInit {

    @Input() errorMessage: string[];

    constructor() { }

    ngOnInit() {
    }

}
